// extracted by mini-css-extract-plugin
module.exports = {"BooleanListFeature":"vz_a bhj_b"};